import { useEffect, useState, useContext, useRef } from 'react'
import { motion } from 'framer-motion'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import { Stack, Box, Typography } from '@mui/material'
import Logo from '../../assets/logo'
import { Outlet, Link } from 'react-router-dom'

export const Foot = ({ }) => {
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <>
      <footer className='w-full py-6'>
        <div className='container flex flex-col gap-2 items-center px-4 md:flex-row md:gap-4 md:px-6 lg:gap-2xl'>
          <div className='flex items-center gap-2 text-center md:order-2 md:justify-center md:gap-4 lg:order-1'>
            <Link className='flex items-center gap-2 font-semibold' to='/'>
              <Logo width={120} />
            </Link>
          </div>
          <div className='flex items-center text-xs text-gray-500 md:order-1 md:justify-center lg:order-2 dark:text-gray-400'>
            <nav className='flex-1 justify-center gap-6 md:flex'>
              <Link className='font-semibold' to='/groups'>
                Groups &nbsp;
              </Link>
              <Link className='font-semibold' to='/about'>
                About &nbsp;
              </Link>
              <Link className='font-semibold' to='/more-info'>
                Answers &nbsp;
              </Link>
              <Link className='font-semibold' to='/terms'>
                Terms &nbsp;
              </Link>
              <span>© 2024 Public Interest Tech Lab (techlab.org). All rights reserved.</span>
            </nav>
          </div>
        </div>
      </footer>
    </>
  )
}
